var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('overview',{attrs:{"state":_vm.state}}),_c('backlog',{attrs:{"state":_vm.state,"restChart":_vm.restChart}}),_c('totalOrder',{attrs:{"state":_vm.state,"type":_vm.type}}),_c('discount',{attrs:{"sevenDataArr":_vm.sevenDataArr}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }